import { combineReducers } from "redux";
import { handleActions } from "redux-actions";
import { DELIVERY_WINDOWS } from "constants/action-types";
import { fetchActions, IFetchStoreState, initialBaseState } from "./base-reducers";
import { IDeliveryWindow } from "constants/delivery-windows";

export interface IDeliveryWindowsState {
    predefined: IFetchStoreState<IDeliveryWindow[]>;
    replenishments: IFetchStoreState<IDeliveryWindow[]>;
}

export const deliveryWindows = combineReducers<IDeliveryWindowsState>({
    predefined: handleActions<IDeliveryWindowsState["predefined"]>(
        fetchActions(DELIVERY_WINDOWS.PREDEFINED.FETCH) as any,
        {
            ...initialBaseState,
        },
    ),
    replenishments: handleActions<IDeliveryWindowsState["replenishments"]>(
        fetchActions(DELIVERY_WINDOWS.REPLENISHMENT.FETCH) as any,
        {
            ...initialBaseState,
        },
    ),
});
